import { render, staticRenderFns } from "./listinsidetalk.vue?vue&type=template&id=c9a403d8&"
import script from "./listinsidetalk.vue?vue&type=script&lang=js&"
export * from "./listinsidetalk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports